import { Field, Form, Formik, useFormikContext } from "formik";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import InputField from "../forms/input-field";
import SelectField from "../forms/select-field";
import { useDispatch } from "react-redux";
import {
  columnAlertAction,
  tableAlertAction,
} from "../../redux/actions/general-action";
import errorToast from "../helper-components/error-toast";
import LoadingOverlay from "../helper-components/overlay-loading";
import CopyIcon from "../../assets/icons/alert-management-icons/copy-icon";
import { Check, DatabaseZap, ReceiptCent, Save } from "lucide-react";
import PlusIcon from "../../assets/icons/alert-management-icons/plus-icon";
import MinusIcon from "../../assets/icons/alert-management-icons/minus-icon";
import Communications from "./communications";
import TextAreaField from "../forms/textarea-field";
import AutoSelectFirstTab from "./auto-select-nav";
import CommunicationInputData from "./communicationInputData";
import Recipients from "./recipients";
import AddButton from "../buttons/button";
import Preview from "./preview";
import { useHotkeys } from "react-hotkeys-hook";
import successToast from "../helper-components/success-toast";
import { Navigate, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  alertCreateAction,
  alertEditAction,
} from "../../redux/actions/alert-action";
import { use } from "react";
import { handleShowErrorToast } from "../helper-components/helper-function";

function CreateEditViewAlert({
  disabled = false,
  userList,
  groups,
  users,
  data,
  page = "add",
}) {
  const [loading, setLoading] = useState(false);
  const [tableType, setTableType] = useState([]);
  const [column, setColumn] = useState([]);
  const [availableVariables, setAvailableVariables] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [copiedText, setCopiedText] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);
  const [groupList, setGroupList] = useState(groups);
  const [usersList, setUsersList] = useState(users);
  const [activeTab, setActiveTab] = useState("");
  const [activeTabData, setActiveTabData] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [heightOfFirstDiv, setHeightOfFirstDiv] = useState(0);
  const [heightOfSecondDiv, setHeightOfSecondDiv] = useState(0);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: "",
  });

  const submitRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const controllerRef = useRef(new AbortController());
  useHotkeys("s", () => {
    if (submitRef.current) {
      submitRef.current.click();
    }
  });
  useEffect(() => {
    return () => {
      controllerRef.current.abort();
    };
  }, []);
  useLayoutEffect(() => {
    const firstDiv = document.querySelector("#first-div");

    // Create ResizeObserver for first div
    const resizeObserver1 = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeightOfFirstDiv(entry.contentRect.height);
      }
    });

    // Start observing both divs
    resizeObserver1.observe(firstDiv);

    // Handle window resize for both divs
    const handleResize = () => {
      const firstDivHeight = firstDiv?.clientHeight;

      if (firstDivHeight) {
        setHeightOfFirstDiv(firstDivHeight);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      resizeObserver1.disconnect();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useLayoutEffect(() => {
    let resizeObserver2;
    let cleanup;

    const setupObserver = () => {
      const secondDiv = document.querySelector("#second-div");

      if (!secondDiv) {
        // Element doesn't exist yet, try again later
        setTimeout(setupObserver, 100);
        return;
      }

      // Check if element is actually visible
      const isVisible =
        secondDiv.offsetParent !== null &&
        window.getComputedStyle(secondDiv).display !== "none";

      if (!isVisible) {
        // Element exists but not visible, try again later
        setTimeout(setupObserver, 100);
        return;
      }

      // Element is visible, set up observer
      resizeObserver2 = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setHeightOfSecondDiv(entry.contentRect.height);
        }
      });

      resizeObserver2.observe(secondDiv);

      const handleResize = () => {
        const secondDivHeight = secondDiv?.clientHeight;
        if (secondDivHeight) {
          setHeightOfSecondDiv(secondDivHeight);
        }
      };

      window.addEventListener("resize", handleResize);

      cleanup = () => {
        resizeObserver2?.disconnect();
        window.removeEventListener("resize", handleResize);
      };
    };

    setupObserver();

    return () => {
      cleanup?.();
    };
  }, []);

  useEffect(() => {
    setGroupList(groups);
    setUsersList(users);
  }, [groups, users]);
  const convertedRecipents = reverseConvertData(
    data?.notificationRecipientsData ?? ""
  );
  console.log(
    "convertedRecipents",
    convertedRecipents,
    data?.notificationRecipientsData
  );
  const [gap, type] = (data?.notificationData?.frequency_time_gap || "").split(
    " "
  );
  const initialFormValues = {
    notificationData: {
      ...(data?.notificationData?.ntf_id && {
        ntf_id: data.notificationData.ntf_id,
      }),
      alert_name: data?.notificationData?.alert_name ?? "",
      priority: data?.notificationData?.priority ?? "",
      condition_type:
        data?.notificationData?.condition_type ?? "Simple Condition",
      transaction_type: data?.notificationData?.transaction_type ?? "",
      table_names: stringToSelectOptions(
        data?.notificationData?.table_names ?? ""
      ),

      column_condition: data?.notificationData?.column_condition ?? "",
      frequency: data?.notificationData?.frequency ?? "",
      frequency_accurrence: data?.notificationData?.frequency_accurrence ?? "",
      frequency_time_gap: data?.notificationData?.frequency_time_gap ?? "",
      timegapValue: gap,
      timegapType: type,
      frequency_first_alert:
        data?.notificationData?.frequency_first_alert ?? "",
      is_email: data?.notificationData?.is_email ?? false,
      is_sms: data?.notificationData?.is_sms ?? false,
      is_push_notification:
        data?.notificationData?.is_push_notification ?? false,
      is_whatsapp: data?.notificationData?.is_whatsapp ?? false,
      sql_query: data?.notificationData?.sql_query ?? "",
      status: data?.notificationData?.status ?? "Active",
    },

    notificationCommunicationData: [
      {
        is_email: data?.notificationCommunicationData?.[0]?.is_email ?? false,
        ...(data?.notificationCommunicationData?.[0]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[0].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[0]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[0].ntf_id,
        }),
        template_name:
          data?.notificationCommunicationData?.[0]?.template_name ?? "",
        subject: data?.notificationCommunicationData?.[0]?.subject ?? "",
        body: data?.notificationCommunicationData?.[0]?.body ?? "",
        attachments:
          data?.notificationCommunicationData?.[0]?.attachments ?? "",
        transaction_status:
          data?.notificationCommunicationData?.[0]?.transaction_status ?? false,
        review_required:
          data?.notificationCommunicationData?.[0]?.review_required ?? false,
        notification_count:
          data?.notificationCommunicationData?.[0]?.notification_count ?? false,
        type: "email",
      },

      {
        is_sms: data?.notificationCommunicationData?.[1]?.is_sms ?? false,
        ...(data?.notificationCommunicationData?.[1]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[1].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[1]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[1].ntf_id,
        }),
        template_name:
          data?.notificationCommunicationData?.[1]?.template_name ?? "",
        subject: data?.notificationCommunicationData?.[1]?.subject ?? "",
        body: data?.notificationCommunicationData?.[1]?.body ?? "",
        attachments:
          data?.notificationCommunicationData?.[1]?.attachments ?? "",
        transaction_status:
          data?.notificationCommunicationData?.[1]?.transaction_status ?? false,
        review_required:
          data?.notificationCommunicationData?.[1]?.review_required ?? false,
        notification_count:
          data?.notificationCommunicationData?.[1]?.notification_count ?? false,
        type: "sms",
      },
      {
        is_whatsapp:
          data?.notificationCommunicationData?.[2]?.is_whatsapp ?? false,
        ...(data?.notificationCommunicationData?.[2]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[2].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[2]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[2].ntf_id,
        }),
        template_name:
          data?.notificationCommunicationData?.[2]?.template_name ?? "",
        subject: data?.notificationCommunicationData?.[2]?.subject ?? "",
        body: data?.notificationCommunicationData?.[2]?.body ?? "",
        attachments:
          data?.notificationCommunicationData?.[2]?.attachments ?? "",
        transaction_status:
          data?.notificationCommunicationData?.[2]?.transaction_status ?? false,
        review_required:
          data?.notificationCommunicationData?.[2]?.review_required ?? false,
        notification_count:
          data?.notificationCommunicationData?.[2]?.notification_count ?? false,
        type: "whatsapp",
      },
      {
        is_push_notification:
          data?.notificationCommunicationData?.[3]?.is_push_notification ??
          false,
        ...(data?.notificationCommunicationData?.[3]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[3].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[3]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[3].ntf_id,
        }),
        template_name:
          data?.notificationCommunicationData?.[3]?.template_name ?? "",
        subject: data?.notificationCommunicationData?.[3]?.subject ?? "",
        body: data?.notificationCommunicationData?.[3]?.body ?? "",
        attachments:
          data?.notificationCommunicationData?.[3]?.attachments ?? "",
        transaction_status:
          data?.notificationCommunicationData?.[3]?.transaction_status ?? false,
        review_required:
          data?.notificationCommunicationData?.[3]?.review_required ?? false,
        notification_count:
          data?.notificationCommunicationData?.[3]?.notification_count ?? false,
        type: "notification",
      },
    ],

    notificationRecipientsData: {
      email: {
        required: convertedRecipents?.email?.required ?? false,
        specific_users: convertedRecipents?.email?.specific_users ?? [""],
        recipient_group: convertedRecipents?.email?.recipient_group ?? [],
        recipient_users: convertedRecipents?.email?.recipient_users ?? [],
        ...(data?.notificationRecipientsData?.[0]?.ntfr_id && {
          ntfr_id: data.notificationRecipientsData?.[0].ntfr_id,
        }),
        ...(data?.notificationRecipientsData?.[0]?.ntfcc_id && {
          ntfcc_id: data.notificationRecipientsData?.[0].ntfcc_id,
        }),
        type: "email",
      },
      push_notification: {
        required: convertedRecipents?.push_notification?.required ?? false,
        specific_users: convertedRecipents?.push_notification
          ?.specific_users ?? [""],
        recipient_group:
          convertedRecipents?.push_notification?.recipient_group ?? [],
        recipient_users:
          convertedRecipents?.push_notification?.recipient_users ?? [],
        ...(data?.notificationRecipientsData?.[3]?.ntfr_id && {
          ntfr_id: data.notificationRecipientsData?.[3]?.ntfr_id,
        }),
        ...(data?.notificationRecipientsData?.[3]?.ntfcc_id && {
          ntfcc_id: data.notificationRecipientsData?.[3]?.ntfcc_id,
        }),
        type: "notification",
      },
      sms: {
        required: convertedRecipents?.sms?.required ?? false,
        specific_users: convertedRecipents?.sms?.specific_users ?? [""],
        recipient_group: convertedRecipents?.sms?.recipient_group ?? [],
        recipient_users: convertedRecipents?.sms?.recipient_users ?? [],
        ...(data?.notificationRecipientsData?.[1]?.ntfr_id && {
          ntfr_id: data.notificationRecipientsData?.[1]?.ntfr_id,
        }),
        ...(data?.notificationRecipientsData?.[1]?.ntfcc_id && {
          ntfcc_id: data.notificationRecipientsData?.[1]?.ntfcc_id,
        }),
        type: "sms",
      },
      whatsapp: {
        required: convertedRecipents?.whatsapp?.required ?? false,
        specific_users: convertedRecipents?.whatsapp?.specific_users ?? [],
        recipient_group: convertedRecipents?.whatsapp?.recipient_group ?? [],
        recipient_users: convertedRecipents?.whatsapp?.recipient_users ?? [],
        ...(data?.notificationRecipientsData?.[2]?.ntfr_id && {
          ntfr_id: data.notificationRecipientsData?.[2]?.ntfr_id,
        }),
        ...(data?.notificationRecipientsData?.[2]?.ntfcc_id && {
          ntfcc_id: data.notificationRecipientsData?.[2]?.ntfcc_id,
        }),
        type: "whatsapp",
      },
    },
    columnConditions: parseColumnConditions(
      data?.notificationData?.column_condition ?? ""
    ),
  };
  const resetValues = {
    notificationData: {
      ...(data?.notificationData?.ntf_id && {
        ntf_id: data.notificationData.ntf_id,
      }),
      alert_name: "",
      priority: "",
      condition_type: "Simple Condition",
      transaction_type: "",
      table_names: [],
      column_condition: "",
      frequency: "",
      frequency_accurrence: "",
      frequency_time_gap: "",
      timegapValue: 0,
      timegapType: "",
      frequency_first_alert: "",
      is_email: false,
      is_sms: false,
      is_push_notification: false,
      is_whatsapp: false,
      sql_query: "",
      status: "",
    },

    notificationCommunicationData: [
      {
        is_email: false,
        ...(data?.notificationCommunicationData?.[0]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[0].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[0]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[0].ntf_id,
        }),
        template_name: "",
        subject: "",
        body: "",
        attachments: "",
        transaction_status: false,
        review_required: false,
        notification_count: false,
        type: "email",
      },

      {
        is_sms: false,
        ...(data?.notificationCommunicationData?.[1]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[1].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[1]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[1].ntf_id,
        }),
        template_name: "",
        subject: "",
        body: "",
        attachments: "",
        transaction_status: false,
        review_required: false,
        notification_count: false,
        type: "sms",
      },
      {
        is_whatsapp: false,
        ...(data?.notificationCommunicationData?.[2]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[2].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[2]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[2].ntf_id,
        }),
        template_name: "",
        subject: "",
        body: "",
        attachments: "",
        transaction_status: false,
        review_required: false,
        notification_count: false,
        type: "whatsapp",
      },
      {
        is_push_notification: false,
        ...(data?.notificationCommunicationData?.[3]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[3].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[3]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[3].ntf_id,
        }),
        template_name: "",
        subject: "",
        body: "",
        attachments: "",
        transaction_status: false,
        review_required: false,
        notification_count: false,
        type: "notification",
      },
    ],

    notificationRecipientsData: {
      email: {
        required: false,
        ...(data?.notificationCommunicationData?.[0]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[0].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[0]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[0].ntf_id,
        }),
        specific_users: [],
        recipient_group: [],
        recipient_users: [],
        type: "email",
      },
      push_notification: {
        required: false,
        ...(data?.notificationCommunicationData?.[3]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[3].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[3]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[3].ntf_id,
        }),
        specific_users: [],
        recipient_group: [],
        recipient_users: [],
        type: "notification",
      },
      sms: {
        required: false,
        ...(data?.notificationCommunicationData?.[1]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[1].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[1]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[1].ntf_id,
        }),
        specific_users: [],
        recipient_group: [],
        recipient_users: [],
        type: "sms",
      },
      whatsapp: {
        required: false,
        ...(data?.notificationCommunicationData?.[2]?.ntfcc_id && {
          ntfcc_id: data.notificationCommunicationData[2].ntfcc_id,
        }),
        ...(data?.notificationCommunicationData?.[2]?.ntf_id && {
          ntf_id: data.notificationCommunicationData[2].ntf_id,
        }),
        specific_users: [],
        recipient_group: [],
        recipient_users: [],
        type: "whatsapp",
      },
    },

    columnConditions: [
      {
        column_name: "",
        condition: "",
        value: "",
        and_or_condition: "",
      },
    ],
  };

  //data for select fields
  const priorityType = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ];
  const conditionType = [
    { label: "Simple Condition", value: "Simple Condition" },
    { label: "SQL Query", value: "SQL Query" },
  ];
  const andOrConditionType = [
    { label: "AND", value: "AND" },
    { label: "OR", value: "OR" },
  ];
  const frequencyType = [
    { label: "Immediate", value: "Immediate" },
    { label: "Daily", value: "Daily" },
    { label: "Weekly", value: "Weekly" },
    { label: "Monthly", value: "Monthly" },
  ];
  const occuranceType = [
    { label: "1 times", value: "1 times" },
    { label: "2 times", value: "2 times" },
    { label: "3 times", value: "3 times" },
  ];

  const timeGapType = [
    { label: "Hours", value: "Hours" },
    { label: "Days", value: "Days" },
  ];

  const alertType = [
    { label: "01:00", value: "01:00" },
    { label: "02:00", value: "02:00" },
    { label: "03:00", value: "03:00" },
    { label: "04:00", value: "04:00" },
    { label: "05:00", value: "05:00" },
    { label: "06:00", value: "06:00" },
    { label: "07:00", value: "07:00" },
    { label: "08:00", value: "08:00" },
    { label: "09:00", value: "09:00" },
    { label: "10:00", value: "10:00" },
    { label: "11:00", value: "11:00" },
    { label: "12:00", value: "12:00" },
    { label: "13:00", value: "13:00" },
    { label: "14:00", value: "14:00" },
    { label: "15:00", value: "15:00" },
    { label: "16:00", value: "16:00" },
    { label: "17:00", value: "17:00" },
    { label: "18:00", value: "18:00" },
    { label: "19:00", value: "19:00" },
    { label: "20:00", value: "20:00" },
    { label: "21:00", value: "21:00" },
    { label: "22:00", value: "22:00" },
    { label: "23:00", value: "23:00" },
    { label: "00:00", value: "00:00" },
  ];

  const columnConditionType = [
    { label: "Equal to", value: "Equal to" },
    { label: "Not equal to", value: "Not equal to" },
    { label: "Greater than", value: "Greater than" },
    { label: "Less than", value: "Less than" },
    { label: "Greater than or equal to", value: "Greater than or equal to" },
    { label: "Less than or equal to", value: "Less than or equal to" },
  ];
  const columnConditionForDate = [
    { label: "Today", value: "Today" },
    { label: "Yesterday", value: "Yesterday" },
    { label: "This week", value: "This week" },
    { label: "This month", value: "This month" },
    { label: "This quarter", value: "This quarter" },
    { label: "This year", value: "This year" },
  ];

  const transactionType = [
    { label: "Bill", value: "Bill" },
    { label: "Return Bill", value: "Return Bill" },
    { label: "Sales order", value: "Sales order" },
    { label: "Delivery Note", value: "Delivery Note" },
    { label: "Sales Invoice", value: "Sales Invoice" },
    { label: "Sales Return", value: "Sales Return" },
    { label: "Sales Credit Note", value: "Sales Credit Note" },
    { label: "Payment IN", value: "Payment IN" },
    { label: "Purchase order", value: "Purchase order" },
    { label: "Goods receipt Note", value: "Goods receipt Note" },
    { label: "Purchase Invoice", value: "Purchase Invoice" },
    { label: "Purchase Return", value: "Purchase Return" },
    { label: "Purchase Credit Note", value: "Purchase Credit Note" },
    { label: "Payment Out", value: "Payment Out" },
    { label: "Product Info", value: "Product Info" },
    { label: "Stock Transfer Request", value: "Stock Transfer Request" },
    { label: "Stock In", value: "Stock In" },
    { label: "Stock Out", value: "Stock Out" },
    { label: "In-Store transfer", value: "In-Store transfer" },
    { label: "Stock Audit", value: "Stock Audit" },
  ];

  // functions
  function parseColumnConditions(conditionStr) {
    const columnConditionType = [
      "Equal to",
      "Not equal to",
      "Greater than",
      "Less than",
      "Greater than or equal to",
      "Less than or equal to",
    ];

    const columnConditionDateType = [
      "Today",
      "Yesterday",
      "This week",
      "This month",
      "This quarter",
      "This year",
    ];

    // Combine and sort by length for longest match first
    const allConditionTypes = [
      ...columnConditionType,
      ...columnConditionDateType,
    ]
      .slice()
      .sort((a, b) => b.length - a.length);

    const andOrKeywords = ["and", "or"];
    const result = [];

    if (!conditionStr || conditionStr.trim() === "") {
      return [
        {
          column_name: "",
          condition: "",
          value: "",
          and_or_condition: "",
        },
      ];
    }

    // Split by 'and' or 'or' while preserving the separators
    const parts = conditionStr.split(/\s+(and|or)\s+/gi);

    for (let i = 0; i < parts.length; i += 2) {
      const conditionPart = parts[i].trim();
      const andOrPart = parts[i + 1]; // This will be 'and'/'or' or undefined

      if (conditionPart) {
        // Build alternation for conditions, allow whitespace in the phrase
        const condPattern = allConditionTypes
          .map((c) => c.replace(/\s/g, "\\s+"))
          .join("|");

        // Match: column_name + condition + optional_value
        const regex = new RegExp(
          `^(\\w+)\\s+(${condPattern})(?:\\s+(.+?))?$`,
          "i"
        );

        const match = regex.exec(conditionPart);

        if (match) {
          const [, column_name, cond, value] = match;

          // Normalize condition text for matching
          const normalizedCond = allConditionTypes.find(
            (c) =>
              c.toLowerCase().replace(/\s+/g, " ") ===
              cond.toLowerCase().replace(/\s+/g, " ")
          );

          const isDateCondition = columnConditionDateType.some(
            (c) =>
              c.toLowerCase().replace(/\s+/g, " ") ===
              cond.toLowerCase().replace(/\s+/g, " ")
          );

          const andOrCondition = andOrPart ? andOrPart.toUpperCase() : "";

          result.push({
            column_name: column_name.trim(),
            condition: normalizedCond || "",
            value: isDateCondition ? "" : value?.trim() ?? "",
            and_or_condition: andOrCondition,
          });
        }
      }
    }

    // Clear the and_or_condition for the last item
    if (result.length > 0) {
      result[result.length - 1].and_or_condition = "";
    }

    console.log(result);
    return result;
  }

  function stringifyColumnConditions(conditions = []) {
    if (!Array.isArray(conditions) || conditions.length === 0) {
      return "";
    }

    // Filter out empty conditions (especially the last one if it's empty and there are multiple)
    const filteredConditions = conditions.filter((cond, index) => {
      const isEmpty =
        (!cond?.column_name || cond.column_name.trim() === "") &&
        (!cond?.condition || cond.condition.trim() === "") &&
        (!cond?.value || cond.value.trim() === "") &&
        (!cond?.and_or_condition || cond.and_or_condition.trim() === "");

      // Only filter out empty items if:
      // 1. It's the last item AND there are multiple items
      // 2. OR it's an empty item in the middle (which shouldn't happen but just in case)
      if (isEmpty) {
        return !(index === conditions.length - 1 && conditions.length > 1);
      }

      return true;
    });

    if (filteredConditions.length === 0) {
      return "";
    }

    const str = filteredConditions
      .map((cond, index) => {
        const {
          column_name = "",
          condition = "",
          value = "",
          and_or_condition = "",
        } = cond;

        const conditionStr = `${column_name} ${condition.toLowerCase()} ${value}`;

        // Only append AND/OR if not last item and and_or_condition exists
        const connector =
          and_or_condition && index < filteredConditions.length - 1
            ? ` ${and_or_condition.toLowerCase()}`
            : "";

        return `${conditionStr}${connector}`;
      })
      .join(" ");

    // Remove multiple spaces and trim
    return str.replace(/\s{2,}/g, " ").trim();
  }

  function stringToSelectOptions(csv) {
    return csv
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => ({
        label: formatLabel(item),
        value: item,
      }));
  }

  // Helper to format label: "invoice_credit_note_item_list" → "Invoice credit note item list"
  function formatLabel(str) {
    const words = str.replace(/_/g, " ").toLowerCase().split(" ");
    return words
      .map((word, index) =>
        index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
      )
      .join(" ");
  }

  function selectOptionsToString(options) {
    // Handle null, undefined, or empty cases
    if (!options) return null;

    // If it's already a string, return it
    if (typeof options === "string") return options;

    // If it's not an array, return null
    if (!Array.isArray(options)) return null;

    // If it's an empty array, return null
    if (options.length === 0) return null;

    // Map the options to their values
    return options.map((opt) => opt.value).join(",");
  }

  const transformApiDataToOptions = (data) => {
    if (data) {
      const transformedData = data.map((table) => ({
        label:
          table.charAt(0).toUpperCase() + table?.slice(1).replace(/_/g, " "), // Capitalize and replace underscores
        value: table,
      }));
      return transformedData;
    }
    return [];
  };

  const onScelectingTransactionType = (values, setFieldValue, table_names) => {
    if (values === "") return;
    const onSuccess = (data) => {
      setLoading(false);
      setTableType(transformApiDataToOptions(data?.data?.tables));
      if (table_names && table_names?.length > 0) {
        setFieldValue("notificationData.table_names", []);
        setFieldValue("columnConditions", [
          {
            column_name: "",
            condition: "",
            value: "",
            and_or_condition: "",
          },
        ]);
      }
      setColumn([]);
      setAvailableVariables([]);
    };
    const onError = (data) => {
      setLoading(false);
      errorToast(data?.data?.message);
    };
    console.log("transaction type selected", values);
    if (!loading) {
      setLoading(true);
      dispatch(tableAlertAction({ table: values }, onSuccess, onError));
    } else return;
  };
  const onScelectingTableType = (values, setFieldValue, allValues) => {
    const defaulltData = {
      column_name: "",
      condition: "",
      value: "",
      and_or_condition: "",
    };
    if (values?.length === 0) {
      return setFieldValue("columnConditions", [defaulltData]);
    }
    let tables = [];
    values.map((table) => tables.push(table.value));
    console.log("tables selected", tables);

    const onSuccess = (data) => {
      let columns = [];
      tables.map((table) => {
        if (data?.data?.columns[table]) {
          columns.push(...data.data.columns[table]);
        }
      });
      setAvailableVariables(columns);
      console.log("updated columns:::::::::::::::::::::::::", columns);
      setColumn(columns);
      setLoading(false);

      const validValues = new Set(columns.map((item) => item.value));
      let newData = JSON.parse(JSON.stringify(allValues.columnConditions));
      let newColumns = newData.filter((col) =>
        validValues.has(col.column_name)
      );

      console.log("newData", newColumns);
      if (newColumns?.length === 0) {
        setFieldValue("columnConditions", [defaulltData]);
      } else setFieldValue("columnConditions", newColumns);
    };
    const onError = (data) => {
      setLoading(false);
      errorToast(data?.data?.message);
    };
    console.log("transaction type selected", values);
    if (!loading) {
      setLoading(true);
      dispatch(
        columnAlertAction(
          { tables: JSON.stringify(tables) },
          onSuccess,
          onError
        )
      );
    } else return;
  };
  function convertData(notificationRecipientsData) {
    const result = [];

    // Define the mapping between original keys and new boolean flags
    const keyMapping = {
      email: "is_email",
      push_notification: "is_push_notification",
      sms: "is_sms",
      whatsapp: "is_whatsapp",
    };

    // Iterate through each notification type
    Object.keys(notificationRecipientsData).forEach((key) => {
      const data = notificationRecipientsData[key];

      // Create new object with the appropriate boolean flag
      const convertedItem = {
        [keyMapping[key]]: notificationRecipientsData[key].required,
        ...data,
      };

      // Remove the 'required' property as it's not needed in the new format
      delete convertedItem.required;
      if (convertedItem.specific_users.length > 0) {
        if (convertedItem.specific_users[0] === "") {
          convertedItem.specific_users = [];
        } else {
          let splitData = convertedItem.specific_users[0].split(",");
          convertedItem.specific_users = splitData;
        }
      }

      result.push(convertedItem);
      console.log(result);
    });
    return result;
  }
  function reverseConvertData(convertedData) {
    // Initialize result with all possible keys having their complete object structure
    const result = {};

    // Define the reverse mapping from boolean flags back to original keys
    const reverseKeyMapping = {
      is_email: "email",
      is_push_notification: "push_notification",
      is_sms: "sms",
      is_whatsapp: "whatsapp",
    };

    // Handle case where data might be undefined or not an array
    if (!convertedData || !Array.isArray(convertedData)) {
      return result;
    }

    // Iterate through each converted item
    convertedData.forEach((item, index) => {
      // Find which notification type this item represents
      const notificationType = Object.keys(reverseKeyMapping).find(
        (key) => item?.[key] === true
      );

      // Debug: Show what flags were found
      const flagsFound = Object.keys(reverseKeyMapping)
        .map((key) => `${key}: ${item?.[key] || "missing"}`)
        .join(", ");
      console.log(`   Flags: ${flagsFound}`);

      if (notificationType) {
        // Get the original key name
        const originalKey = reverseKeyMapping[notificationType];

        // Create a copy of the item without the boolean flag
        const originalItem = { ...item };
        delete originalItem[notificationType];

        // Add required: true to match the target format
        originalItem.required = true;

        // Store in result using original key
        result[originalKey] = originalItem;
      }
    });

    const convertedCount = Object.keys(result).filter(
      (key) => result[key].created_by // Check if it has actual data beyond defaults
    ).length;
    console.log(result);
    return result;
  }

  const onSave = async (values, { validateForm, errors }) => {
    let action = alertCreateAction;
    if (page === "edit") action = alertEditAction;
    const onSuccess = (data) => {
      setLoading(false);
      successToast(data?.data?.message);
      navigate("/alerts");
    };
    const onError = (data) => {
      setLoading(false);
      errorToast(data?.data?.message);
    };
    if (!loading) {
      let finalData = {
        notificationData: values.notificationData,
        notificationCommunicationData: values.notificationCommunicationData,
        notificationRecipientsData: convertData(
          values.notificationRecipientsData
        ),
      };

      const key = finalData.notificationData;
      key.frequency_time_gap = [key.timegapValue, key.timegapType].join(" ");
      key.table_names = selectOptionsToString(key.table_names);
      key.column_condition = stringifyColumnConditions(values.columnConditions);

      setLoading(true);
      dispatch(action(finalData, onSuccess, onError));
    } else return;
  };
  const onClear = (setValues) => {
    setValues(resetValues);
    setAvailableVariables([]);
    setColumn([]);
    setTableType([]);
  };
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      setShowNotification(true);

      // Clear existing timeout if it exists
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Set new timeout and store its ID
      const newTimeoutId = setTimeout(() => {
        setShowNotification(false);
      }, 2000);

      setTimeoutId(newTimeoutId);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const areAllFieldsFilled = (columnConditions) => {
    for (const item of columnConditions) {
      const name = item.column_name?.trim();
      const cond = item.condition?.trim();
      const value = item.value?.trim();
      const andOr = item.and_or_condition?.trim();
      const isDateType = name.endsWith("_date");
      if (!name || !cond || (!isDateType && !value) || !andOr) {
        return false;
      }
    }
    return true;
  };

  const tabConfig = [
    { id: "Email", key: "is_email" },
    { id: "SMS", key: "is_sms" },
    { id: "WhatsApp", key: "is_whatsapp" },
    { id: "Push Notification", key: "is_push_notification" },
  ];

  const hasCalledRef = useRef({
    transactionType: false,
    tableType: false,
  });

  useEffect(() => {
    const transactionType = data?.notificationData?.transaction_type;
    const tableType = data?.notificationData?.table_names;

    if (transactionType) {
      if (transactionType === "") return;

      let tables = tableType.split(",");

      const onSuccess = (data) => {
        setTableType(transformApiDataToOptions(data?.data?.tables));
        if (tableType === "" || tableType === null || tableType === undefined) {
          setLoading(false);
          return;
        }

        const onSuccessTable = (data) => {
          setLoading(false);
          let columns = [];
          tables.map((table) => {
            if (data?.data?.columns[table]) {
              columns.push(...data.data.columns[table]);
            }
          });
          setAvailableVariables(columns);
          setColumn(columns);
        };
        const onErrorTable = (data) => {
          setLoading(false);
          errorToast(data?.data?.message);
        };
        if (!loading) {
          dispatch(
            columnAlertAction(
              { tables: JSON.stringify(tables) },
              onSuccessTable,
              onErrorTable
            )
          );
        } else return;
      };
      const onError = (data) => {
        setLoading(false);
        errorToast(data?.data?.message);
      };
      if (!loading) {
        setLoading(true);
        dispatch(
          tableAlertAction({ table: transactionType }, onSuccess, onError)
        );
      } else return;
    }
  }, [data]);

  function FirstDivHeightManager({ setHeightOfFirstDiv }) {
    const { values } = useFormikContext();

    useLayoutEffect(() => {
      const updateHeights = () => {
        setTimeout(() => {
          const firstDivHeight =
            document.querySelector("#first-div")?.clientHeight;

          if (firstDivHeight) {
            setHeightOfFirstDiv(firstDivHeight);
          }
        }, 0);
      };

      updateHeights();

      window.addEventListener("resize", updateHeights);

      return () => {
        window.removeEventListener("resize", updateHeights);
      };
    }, [values.notificationData.sql_query, setHeightOfFirstDiv]);
  }
  function SecondDivHeightManager({ setHeightOfSecondDiv }) {
    const { values } = useFormikContext();

    useLayoutEffect(() => {
      const updateHeights = () => {
        setTimeout(() => {
          const secondDivHeight =
            document.querySelector("#second-div")?.clientHeight;

          if (secondDivHeight) {
            setHeightOfSecondDiv(secondDivHeight);
          }
        }, 0);
      };

      updateHeights();

      window.addEventListener("resize", updateHeights);

      return () => {
        window.removeEventListener("resize", updateHeights);
      };
    }, [values.notificationCommunicationData, setHeightOfSecondDiv]);
  }

  const handleMouseMove = (e, text) => {
    setTooltip({
      visible: true,
      x: e.clientX + 10,
      y: e.clientY + 10,
      text: text,
    });
  };

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, visible: false });
  };

  function flattenErrors(errors, prefix = "", signal) {
    if (signal?.aborted) return [];

    let messages = [];
    for (const key in errors) {
      if (signal?.aborted) break;
      if (!errors.hasOwnProperty(key)) continue;

      const value = errors[key];
      if (typeof value === "string") {
        messages.push({ field: prefix + key, message: value });
      } else if (typeof value === "object" && value !== null) {
        messages = messages.concat(
          flattenErrors(value, `${prefix}${key}.`, signal)
        );
      }
    }
    return messages;
  }

  const validationSchema = Yup.object().shape({
    notificationData: Yup.object()
      .shape({
        alert_name: Yup.string().required("Alert name is required"),
        priority: Yup.string().required("Priority is required"),
        condition_type: Yup.string().required("Condition type is required"),
        transaction_type: Yup.string().required("Transaction Type is required"),
        table_names: Yup.array()
          .min(1, "Table is required")
          .required("Table is required"),
        frequency: Yup.string().required("Frequency is required"),
        frequency_accurrence: Yup.string().when("frequency", {
          is: (frequency) => frequency !== "Immediate",
          then: (schema) =>
            schema.required("Frequency occurrence is required").test({
              name: "frequency-occurrence-range",
              message: "Frequency occurrence must be between 1 and 20",
              test: function (value) {
                if (!value) return false;
                const numValue = parseInt(value, 10);
                return !isNaN(numValue) && numValue >= 1 && numValue <= 20;
              },
            }),
          otherwise: (schema) => schema,
        }),

        timegapValue: Yup.number().when(["frequency", "timegapType"], {
          is: (frequency, timegapType) =>
            frequency !== "Immediate" && timegapType,
          then: (schema) =>
            schema
              .required("Timegap value is required")
              .min(1, "Timegap value must be greater than 0")
              .when("timegapType", {
                is: "Hours",
                then: (schema) =>
                  schema.max(24, "Hours must be between 1 and 24"),
                otherwise: (schema) =>
                  schema.max(31, "Days must be between 1 and 31"),
              }),
          otherwise: (schema) => schema,
        }),

        timegapType: Yup.string().when("frequency", {
          is: (frequency) => frequency !== "Immediate",
          then: (schema) => schema.required("Timegap type is required"),
          otherwise: (schema) => schema,
        }),

        frequency_first_alert: Yup.string().when("frequency", {
          is: (frequency) => frequency !== "Immediate",
          then: (schema) =>
            schema.required("Frequency first alert is required"),
          otherwise: (schema) => schema,
        }),
        is_email: Yup.boolean(),
        is_sms: Yup.boolean(),
        is_push_notification: Yup.boolean(),
        is_whatsapp: Yup.boolean(),
        sql_query: Yup.string().when("condition_type", {
          is: "SQL Query",
          then: (schema) => schema.required("SQL Query is required"),
          otherwise: (schema) => schema,
        }),
      })
      .test({
        name: "at-least-one-channel",
        message:
          "At least one communication channel (Email, SMS, Push, WhatsApp) must be enabled",
        test: function (value) {
          return !!(
            value?.is_email ||
            value?.is_sms ||
            value?.is_push_notification ||
            value?.is_whatsapp
          );
        },
      }),
    columnConditions: Yup.array().when(["notificationData.condition_type"], {
      is: (condition_type) => condition_type === "Simple Condition",
      then: (schema) =>
        schema
          .transform((value) => {
            if (!Array.isArray(value)) return value;

            // Only remove empty last item if array length > 1
            if (value.length > 1) {
              const lastItem = value[value.length - 1];
              const isEmptyLastItem =
                (!lastItem?.column_name ||
                  lastItem.column_name.trim() === "") &&
                (!lastItem?.condition || lastItem.condition.trim() === "") &&
                (!lastItem?.value || lastItem.value.trim() === "") &&
                (!lastItem?.and_or_condition ||
                  lastItem.and_or_condition.trim() === "");

              if (isEmptyLastItem) {
                return value.slice(0, -1);
              }
            }
            // If length is 1, don't remove it - let validation handle it

            return value;
          })
          .min(
            1,
            "At least one column condition is required for Simple Condition"
          )
          .of(
            Yup.object().shape({
              column_name: Yup.string().required("Column name is required"),
              condition: Yup.string().required("Condition is required"),
              value: Yup.string().when("column_name", {
                is: (column_name) =>
                  column_name && column_name.endsWith("_date"),
                then: (schema) => schema,
                otherwise: (schema) => schema.required("Value is required"),
              }),
              and_or_condition: Yup.string().when("$index", {
                is: (index, context) => {
                  return (
                    context?.parent?.length > 1 &&
                    index < context.parent.length - 1
                  );
                },
                then: (schema) =>
                  schema.required("AND/OR condition is required"),
                otherwise: (schema) => schema,
              }),
            })
          ),
      otherwise: (schema) => schema,
    }),
    notificationCommunicationData: Yup.array().test({
      name: "communication-data-validation",
      message: "",
      test: function (communicationData) {
        const { notificationData } = this.parent;
        const errors = [];

        // Email validation (index 0)
        if (notificationData?.is_email && communicationData?.[0]) {
          const emailData = communicationData[0];
          if (!emailData.template_name) {
            errors.push(
              this.createError({
                path: `${this.path}[0].template_name`,
                message: "Email template name is required",
              })
            );
          }
          if (!emailData.subject) {
            errors.push(
              this.createError({
                path: `${this.path}[0].subject`,
                message: "Email subject is required",
              })
            );
          }
          if (!emailData.body) {
            errors.push(
              this.createError({
                path: `${this.path}[0].body`,
                message: "Email body is required",
              })
            );
          }
        }

        // SMS validation (index 1)
        if (notificationData?.is_sms && communicationData?.[1]) {
          const smsData = communicationData[1];
          if (!smsData.template_name) {
            errors.push(
              this.createError({
                path: `${this.path}[1].template_name`,
                message: "SMS template name is required",
              })
            );
          }
          if (!smsData.body) {
            errors.push(
              this.createError({
                path: `${this.path}[1].body`,
                message: "SMS body is required",
              })
            );
          }
        }

        // WhatsApp validation (index 2)
        if (notificationData?.is_whatsapp && communicationData?.[2]) {
          const whatsappData = communicationData[2];
          if (!whatsappData.template_name) {
            errors.push(
              this.createError({
                path: `${this.path}[2].template_name`,
                message: "WhatsApp template name is required",
              })
            );
          }
          if (!whatsappData.body) {
            errors.push(
              this.createError({
                path: `${this.path}[2].body`,
                message: "WhatsApp body is required",
              })
            );
          }
        }

        // Push notification validation (index 3)
        if (notificationData?.is_push_notification && communicationData?.[3]) {
          const pushData = communicationData[3];
          if (!pushData.template_name) {
            errors.push(
              this.createError({
                path: `${this.path}[3].template_name`,
                message: "Push notification template name is required",
              })
            );
          }
          if (!pushData.subject) {
            errors.push(
              this.createError({
                path: `${this.path}[3].subject`,
                message: "Push notification subject is required",
              })
            );
          }
          if (!pushData.body) {
            errors.push(
              this.createError({
                path: `${this.path}[3].body`,
                message: "Push notification body is required",
              })
            );
          }
        }

        // Return errors if any, otherwise return true
        if (errors.length > 0) {
          return new Yup.ValidationError(errors);
        }
        return true;
      },
    }),
    notificationRecipientsData: Yup.object().shape({
      email: Yup.object().test({
        name: "email-recipients-validation",
        message: "",
        test: function (value) {
          if (!value?.required) return true;

          const errors = [];
          const hasRecipientUsers =
            value?.recipient_users && value.recipient_users.length > 0;
          const hasRecipientGroup =
            value?.recipient_group && value.recipient_group.length > 0;
          const hasSpecificUsers =
            value?.specific_users &&
            value.specific_users.length > 0 &&
            value.specific_users.some((user) => {
              if (!user || user.trim() === "") return false;
              // Check if it contains comma-separated emails or single email
              const emails = user
                .split(",")
                .map((email) => email.trim())
                .filter((email) => email !== "");
              return emails.length > 0;
            });

          // Check if BOTH recipient_users AND recipient_group are provided OR specific_users is provided
          if ((!hasRecipientUsers || !hasRecipientGroup) && !hasSpecificUsers) {
            errors.push(
              this.createError({
                path: `${this.path}.recipients`,
                message:
                  "Either both recipient users and recipient group must be provided, or specific users must be provided for email",
              })
            );
          }

          // Validate specific_users contains valid emails
          if (hasSpecificUsers) {
            value.specific_users.forEach((emailString, index) => {
              if (emailString && emailString.trim() !== "") {
                // Split by comma in case multiple emails are in one string
                const emails = emailString
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email !== "");
                emails.forEach((email, emailIndex) => {
                  if (!Yup.string().email().isValidSync(email)) {
                    errors.push(
                      this.createError({
                        path: `${this.path}.specific_users[${index}]`,
                        message: `Invalid email address: ${email}`,
                      })
                    );
                  }
                });
              }
            });
          }

          if (errors.length > 0) {
            return new Yup.ValidationError(errors);
          }
          return true;
        },
      }),

      sms: Yup.object().test({
        name: "sms-recipients-validation",
        message: "",
        test: function (value) {
          if (!value?.required) return true;

          const hasRecipientUsers =
            value?.recipient_users && value.recipient_users.length > 0;
          const hasRecipientGroup =
            value?.recipient_group && value.recipient_group.length > 0;
          const hasSpecificUsers =
            value?.specific_users &&
            value.specific_users.length > 0 &&
            value.specific_users.some((user) => {
              if (!user || user.trim() === "") return false;
              // Check if it contains comma-separated emails or single email
              const emails = user
                .split(",")
                .map((email) => email.trim())
                .filter((email) => email !== "");
              return emails.length > 0;
            });

          if ((!hasRecipientUsers || !hasRecipientGroup) && !hasSpecificUsers) {
            return this.createError({
              path: `${this.path}.recipients`,
              message:
                "Either both recipient users and recipient group must be provided, or specific users must be provided for SMS",
            });
          }

          // Validate specific_users contains valid emails for SMS
          if (hasSpecificUsers) {
            const errors = [];
            value.specific_users.forEach((emailString, index) => {
              if (emailString && emailString.trim() !== "") {
                // Split by comma in case multiple emails are in one string
                const emails = emailString
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email !== "");
                emails.forEach((email, emailIndex) => {
                  if (!Yup.string().email().isValidSync(email)) {
                    errors.push(
                      this.createError({
                        path: `${this.path}.specific_users[${index}]`,
                        message: `Invalid email address: ${email}`,
                      })
                    );
                  }
                });
              }
            });

            if (errors.length > 0) {
              return new Yup.ValidationError(errors);
            }
          }
          return true;
        },
      }),

      whatsapp: Yup.object().test({
        name: "whatsapp-recipients-validation",
        message: "",
        test: function (value) {
          if (!value?.required) return true;

          const hasRecipientUsers =
            value?.recipient_users && value.recipient_users.length > 0;
          const hasRecipientGroup =
            value?.recipient_group && value.recipient_group.length > 0;
          const hasSpecificUsers =
            value?.specific_users &&
            value.specific_users.length > 0 &&
            value.specific_users.some((user) => user && user.trim() !== "");

          if ((!hasRecipientUsers || !hasRecipientGroup) && !hasSpecificUsers) {
            return this.createError({
              path: `${this.path}.recipients`,
              message:
                "Either both recipient users and recipient group must be provided, or specific users must be provided for WhatsApp",
            });
          }
          if (hasSpecificUsers) {
            const errors = [];
            value.specific_users.forEach((emailString, index) => {
              if (emailString && emailString.trim() !== "") {
                // Split by comma in case multiple emails are in one string
                const emails = emailString
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email !== "");
                emails.forEach((email, emailIndex) => {
                  if (!Yup.string().email().isValidSync(email)) {
                    errors.push(
                      this.createError({
                        path: `${this.path}.specific_users[${index}]`,
                        message: `Invalid email address: ${email}`,
                      })
                    );
                  }
                });
              }
            });

            if (errors.length > 0) {
              return new Yup.ValidationError(errors);
            }
          }
          return true;
        },
      }),

      push_notification: Yup.object().test({
        name: "push-recipients-validation",
        message: "",
        test: function (value) {
          if (!value?.required) return true;

          const hasRecipientUsers =
            value?.recipient_users && value.recipient_users.length > 0;
          const hasRecipientGroup =
            value?.recipient_group && value.recipient_group.length > 0;
          const hasSpecificUsers =
            value?.specific_users &&
            value.specific_users.length > 0 &&
            value.specific_users.some((user) => {
              if (!user || user.trim() === "") return false;
              // Check if it contains comma-separated emails or single email
              const emails = user
                .split(",")
                .map((email) => email.trim())
                .filter((email) => email !== "");
              return emails.length > 0;
            });

          if ((!hasRecipientUsers || !hasRecipientGroup) && !hasSpecificUsers) {
            return this.createError({
              path: `${this.path}.recipients`,
              message:
                "Either both recipient users and recipient group must be provided, or specific users must be provided for push notification",
            });
          }

          // Validate specific_users contains valid emails for push notification
          if (hasSpecificUsers) {
            const errors = [];
            value.specific_users.forEach((emailString, index) => {
              if (emailString && emailString.trim() !== "") {
                // Split by comma in case multiple emails are in one string
                const emails = emailString
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email !== "");
                emails.forEach((email, emailIndex) => {
                  if (!Yup.string().email().isValidSync(email)) {
                    errors.push(
                      this.createError({
                        path: `${this.path}.specific_users[${index}]`,
                        message: `Invalid email address: ${email}`,
                      })
                    );
                  }
                });
              }
            });

            if (errors.length > 0) {
              return new Yup.ValidationError(errors);
            }
          }
          return true;
        },
      }),
    }),
  });

  return (
    <>
      {showPreview && (
        <Preview
          setShowPreview={setShowPreview}
          showPreview={showPreview}
          activeTab={activeTab}
          activeTabData={activeTabData}
        />
      )}

      {/* Move the notification OUTSIDE of the Form component */}
      <div
        className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-out z-50 ${
          showNotification
            ? "translate-y-0 opacity-100"
            : "translate-y-2 opacity-0 pointer-events-none"
        }`}
      >
        <div className="bg-black text-white px-4 py-3 rounded-lg shadow-lg flex items-center space-x-2 max-w-sm">
          <Check size={16} className="text-green flex-shrink-0" />
          <span className="text-sm font-medium">Copied to clipboard</span>
          <span className="text-xs text-green truncate ml-2">
            {copiedText.length > 20
              ? `${copiedText.substring(0, 20)}...`
              : copiedText}
          </span>
        </div>
      </div>
      <Formik
        enableReinitialize
        initialValues={initialFormValues}
        validationSchema={validationSchema}
        onSubmit={onSave}
      >
        {({
          values,
          setFieldValue,
          resetForm,
          setValues,
          validateForm,
          errors,
        }) => {
          const visibleTabs = tabConfig.filter(
            (tab) => values.notificationData[tab.key]
          );
          console.log("====================", values);
          return (
            <Form>
              <div className="flex flex-row gap-6 p-6 w-full">
                <FirstDivHeightManager
                  setHeightOfFirstDiv={setHeightOfFirstDiv}
                />
                <SecondDivHeightManager
                  setHeightOfSecondDiv={setHeightOfSecondDiv}
                />

                <div
                  className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 transition-all duration-300 ease-out ${
                    showNotification
                      ? "translate-y-0 opacity-100"
                      : "translate-y-2 opacity-0 pointer-events-none"
                  }`}
                >
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-lg shadow-lg flex items-center space-x-2 max-w-sm">
                    <Check size={16} className="text-green-400 flex-shrink-0" />
                    <span className="text-sm font-medium">
                      Copied to clipboard
                    </span>
                    <span className="text-xs text-gray-300 truncate ml-2">
                      {copiedText.length > 20
                        ? `${copiedText.substring(0, 20)}...`
                        : copiedText}
                    </span>
                  </div>
                </div>
                <div
                  id="first-div"
                  className="flex  grow basis-[72%]  flex-col space-y-[30px] border   p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]"
                >
                  <div className="flex flex-col gap-[17px] ">
                    <label
                      className={
                        "text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-sub-title-fw)]"
                      }
                    >
                      Basic Information
                    </label>

                    <div className="flex flex-row gap-4 w-full ">
                      <InputField
                        errMsgContainerClass="hidden"
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`notificationData.alert_name`}
                        placeholder="Enter alert name"
                        label="Alert Name"
                        isDisabled={disabled}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                      <SelectField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        label="Priority"
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={disabled}
                        errMsgContainerClass="hidden"
                        placeholder="Select priority"
                        options={priorityType}
                        name={`notificationData.priority`}
                        defaultValue={priorityType.find(
                          (option) =>
                            option.value === values.notificationData.priority
                        )}
                        isSearchable={true}
                        isRequired={false}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-[17px]">
                    <label
                      className={
                        "text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-sub-title-fw)]"
                      }
                    >
                      Trigger Conditions
                    </label>
                    <div className="flex flex-col gap-4 w-full ">
                      <SelectField
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        label="Condition Type"
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={disabled}
                        errMsgContainerClass="hidden"
                        placeholder="Select Condition Type"
                        options={conditionType}
                        name={`notificationData.condition_type`}
                        defaultValue={conditionType.find(
                          (option) =>
                            option.value ===
                            values?.notificationData?.condition_type
                        )}
                        isSearchable={true}
                        isRequired={false}
                      />
                      <div className="flex flex-row gap-4 w-full">
                        <SelectField
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          label="Transaction Type"
                          general_color="true"
                          borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                          isContainer={true}
                          containerClass={`${
                            disabled ? "cursor-not-allowed" : ""
                          } w-full flex flex-col gap-2`}
                          parentClass={`${
                            disabled ? "cursor-not-allowed" : ""
                          } w-full flex flex-col gap-2`}
                          isDisabled={disabled}
                          errMsgContainerClass="hidden"
                          placeholder="Select Transaction Type"
                          options={transactionType}
                          handleSelected={(e) => {
                            onScelectingTransactionType(
                              e.value,
                              setFieldValue,
                              values?.notificationData?.table_names
                            );
                          }}
                          name={`notificationData.transaction_type`}
                          defaultValue={transactionType.find(
                            (option) =>
                              option.value ===
                              values.notificationData.transaction_type
                          )}
                          isSearchable={true}
                          isRequired={false}
                        />
                        <SelectField
                          labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          label="Table"
                          isDisabled={disabled}
                          general_color="true"
                          isMulti={true}
                          borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                          isContainer={true}
                          containerClass={`${
                            disabled ? "cursor-not-allowed" : ""
                          } w-full flex flex-col gap-2`}
                          parentClass={`${
                            disabled ? "cursor-not-allowed" : ""
                          } w-full flex flex-col gap-2`}
                          errMsgContainerClass="hidden"
                          handleSelected={(e) => {
                            onScelectingTableType(e, setFieldValue, values);
                          }}
                          placeholder="Select Tables"
                          options={tableType}
                          name={`notificationData.table_names`}
                          defaultValue={values.notificationData?.table_names}
                          isSearchable={true}
                          isRequired={false}
                        />
                      </div>
                      {values.notificationData.condition_type ==
                      "Simple Condition" ? (
                        values?.columnConditions?.map((obj, i) => (
                          <div className="flex flex-row gap-4  w-full">
                            <SelectField
                              defaultValue={column.find(
                                (option) =>
                                  option.value ===
                                  values.columnConditions[i].column_name
                              )}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              label="Column"
                              isDisabled={disabled}
                              general_color="true"
                              borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                              isContainer={true}
                              containerClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              parentClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              errMsgContainerClass="hidden"
                              placeholder="Select Column"
                              options={column}
                              name={`columnConditions[${i}].column_name`}
                              isSearchable={true}
                              isRequired={false}
                            />
                            <SelectField
                              key={`${i}-${JSON.stringify(
                                values.columnConditions[i]
                              )}`}
                              defaultValue={(() => {
                                const name =
                                  values.columnConditions[i].column_name;
                                const condition =
                                  values.columnConditions[i].condition;
                                // if (!name || !condition) return null;
                                console.log(
                                  "name.endsWith('_date')",
                                  name.endsWith("_date")
                                );
                                const type = name?.endsWith("_date")
                                  ? columnConditionForDate
                                  : columnConditionType;
                                console.log(type, condition);
                                return (
                                  type.find(
                                    (option) => option.value === condition
                                  ) || null
                                );
                              })()}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              label="Condition"
                              general_color="true"
                              borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                              isContainer={true}
                              containerClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              parentClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              isDisabled={disabled}
                              errMsgContainerClass="hidden"
                              placeholder="Select Conditions"
                              options={
                                values.columnConditions[i].column_name.endsWith(
                                  "_date"
                                )
                                  ? columnConditionForDate
                                  : columnConditionType
                              }
                              name={`columnConditions[${i}].condition`}
                              id={`columnConditions[${i}].condition`}
                              handleSelected={(selected) => {
                                console.log("selected condition", selected);
                                setFieldValue(
                                  `columnConditions[${i}].condition`,
                                  selected?.value
                                );
                              }}
                              isSearchable={true}
                              isRequired={false}
                            />

                            <InputField
                              errMsgContainerClass="hidden"
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              parentClass="flex  flex-col gap-2 w-full align-end "
                              name={`columnConditions[${i}].value`}
                              placeholder="Enter value"
                              label="Value"
                              isDisabled={(() => {
                                const name =
                                  values.columnConditions[i].column_name;
                                const isDateType = name.endsWith("_date");
                                if (isDateType)
                                  values.columnConditions[i].value = "";
                                const status = isDateType || disabled;
                                return status;
                              })()}
                              defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                              containerClass="w-full"
                            />
                            <SelectField
                              defaultValue={andOrConditionType.find(
                                (option) =>
                                  option.value ===
                                  values.columnConditions[i].and_or_condition
                              )}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              label="Condition"
                              general_color="true"
                              borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                              isContainer={true}
                              containerClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              parentClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } w-full flex flex-col gap-2`}
                              isDisabled={disabled}
                              errMsgContainerClass="hidden"
                              placeholder="Select Conditions"
                              options={andOrConditionType}
                              handleSelected={(selected) => {
                                console.log("selected condition", selected);
                                setFieldValue(
                                  `columnConditions[${i}].and_or_condition`,
                                  selected?.value
                                );
                              }}
                              name={`columnConditions[${i}].and_or_condition`}
                              id={`columnConditions[${i}].and_or_condition`}
                              isSearchable={true}
                              isRequired={false}
                            />
                            <div>
                              {(() => {
                                if (i === values.columnConditions.length - 1) {
                                  return (
                                    <div
                                      className={`w-10 h-10 p-4  ${
                                        disabled ? "" : "cursor-pointer"
                                      }  rounded-lg mt-6 ${
                                        i === values.columnConditions.length - 1
                                          ? "bg-primary"
                                          : "border border-[var(--alert-management-border-color)] flex items-center justify-center"
                                      }`}
                                      onClick={() => {
                                        if (disabled) return;
                                        if (
                                          values.columnConditions.length <
                                          availableVariables.length
                                        ) {
                                          if (
                                            areAllFieldsFilled(
                                              values.columnConditions
                                            )
                                          ) {
                                            let a = JSON.parse(
                                              JSON.stringify(
                                                values.columnConditions
                                              )
                                            );
                                            a.push({
                                              column_name: "",
                                              condition: "",
                                              value: "",
                                              and_or_condition: "",
                                            });
                                            setFieldValue(
                                              "columnConditions",
                                              a
                                            );
                                          } else {
                                            errorToast(
                                              "Please fill all fields in the last condition before adding a new one"
                                            );
                                          }
                                        } else if (
                                          availableVariables.length === 0
                                        ) {
                                          errorToast(
                                            "Please select a transaction type and table first"
                                          );
                                        } else
                                          errorToast(
                                            "Maximum number of conditions reached"
                                          );
                                      }}
                                    >
                                      {" "}
                                      <PlusIcon />
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      className={`w-10 h-10 p-4  ${
                                        disabled ? "" : "cursor-pointer"
                                      }  rounded-lg mt-6 ${
                                        i === values.columnConditions.length - 1
                                          ? "bg-primary"
                                          : "border border-[var(--alert-management-border-color)] flex items-center justify-center"
                                      }`}
                                      onClick={() => {
                                        if (disabled) return;
                                        let a = JSON.parse(
                                          JSON.stringify(
                                            values.columnConditions
                                          )
                                        );
                                        a.splice(i, 1);
                                        setFieldValue("columnConditions", a);
                                      }}
                                    >
                                      {" "}
                                      <MinusIcon />
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="flex flex-col gap-2 w-full">
                          <lable
                            className={`text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                          >
                            Enter Query
                          </lable>
                          <Field
                            as="textarea"
                            disabled={disabled}
                            name="notificationData.sql_query"
                            placeholder="Enter SQL Query Here"
                            className={`${
                              disabled ? "cursor-not-allowed" : ""
                            } text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)] min-h-[104px] border border-[var(--alert-management-input-border-color)] rounded-lg w-full p-3 focus:outline-none focus:border-[var(--alert-management-input-border-color)] focus:text-[var(--alert-management-label-fs)] focus:bg-inherit`}
                          />
                        </div>
                      )}
                      <SelectField
                        defaultValue={frequencyType.find(
                          (option) =>
                            option.value === values.notificationData.frequency
                        )}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        label="Frequency"
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={disabled}
                        errMsgContainerClass="hidden"
                        placeholder="Select Frequency"
                        options={frequencyType}
                        name={`notificationData.frequency`}
                        id={`notificationData.frequency`}
                        isSearchable={true}
                        isRequired={false}
                      />
                      {values.notificationData.frequency !== "Immediate" &&
                        values.notificationData.frequency !== "" && (
                          <div className="flex flex-row gap-4 w-full">
                            <InputField
                              errMsgContainerClass="hidden"
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              parentClass="flex-1 flex  flex-col gap-2 w-full align-end "
                              name={`notificationData.frequency_accurrence`}
                              placeholder="Enter occurrence"
                              label="Occurrence"
                              isDisabled={disabled}
                              defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-variable-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                              containerClass="flex-1 w-full h-min"
                              type="number"
                              min={1}
                              max={20}
                            />
                            <div className=" flex-[2] flex flex-col gap-2 w-full">
                              {" "}
                              <lable
                                className={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              >
                                {" "}
                                Time Gap
                              </lable>
                              <div className="flex flex-row gap-0 w-full">
                                <InputField
                                  errMsgContainerClass="hidden"
                                  parentClass="flex-1  flex-col gap-2 w-full align-end "
                                  name={`notificationData.timegapValue`}
                                  placeholder="Enter number"
                                  label=""
                                  isDisabled={disabled}
                                  defaultInputClass={`min-h-[42px] rounded-l-[8px]  px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-variable-fw)]   placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                                  containerClass=" flex-1 w-full h-min"
                                  type="number"
                                  min={1}
                                  max={
                                    values.notificationData.timegapType ===
                                    "Hours"
                                      ? 24
                                      : 31
                                  }
                                />
                                <SelectField
                                  defaultValue={timeGapType.find(
                                    (option) =>
                                      option.value ==
                                      values.notificationData.timegapType
                                  )}
                                  labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                                  label=""
                                  general_color="true"
                                  // borderclass=""
                                  // inputBorder="  border  border-[var(--inputBorder)]"
                                  defaultInputClass="min-h-[42px] rounded-r-[8px] bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--input-font-weight)] input-field-no-spin-buttons placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:border-[var(--input-focus)] focus:text-[var(--input-color)] focus:bg-[var(--input-bg)] "
                                  isContainer={true}
                                  containerClass={`${
                                    disabled ? "cursor-not-allowed" : ""
                                  } flex-1 w-full flex flex-col gap-2`}
                                  parentClass={`${
                                    disabled ? "cursor-not-allowed" : ""
                                  }  flex-1 w-full flex flex-col gap-2`}
                                  isDisabled={disabled}
                                  errMsgContainerClass="hidden"
                                  placeholder="Select Time Gap"
                                  options={timeGapType}
                                  name={`notificationData.timegapType`}
                                  isSearchable={true}
                                  isRequired={false}
                                />
                              </div>
                            </div>
                            <SelectField
                              defaultValue={alertType.find(
                                (option) =>
                                  option.value ===
                                  values.notificationData.frequency_first_alert
                              )}
                              labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                              label="First Alert"
                              general_color="true"
                              borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                              isContainer={true}
                              containerClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              } flex-1 w-full flex flex-col gap-2`}
                              parentClass={`${
                                disabled ? "cursor-not-allowed" : ""
                              }  flex-1 w-full flex flex-col gap-2`}
                              isDisabled={disabled}
                              errMsgContainerClass="hidden"
                              placeholder="Select First Alert"
                              options={alertType}
                              name={`notificationData.frequency_first_alert`}
                              isSearchable={true}
                              isRequired={false}
                            />
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="flex flex-col gap-[17px] w-full">
                    <label
                      className={
                        "text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-sub-title-fw)]"
                      }
                    >
                      Communication Channels
                    </label>
                    <div className="flex flex-row gap-4 w-full">
                      <Communications
                        type="Email"
                        input="is_email"
                        index={0}
                        disabled={disabled}
                      />
                      <Communications
                        type="Sms"
                        input="is_sms"
                        index={1}
                        disabled={disabled}
                      />
                      <Communications
                        type="Whatsapp"
                        input="is_whatsapp"
                        index={2}
                        disabled={disabled}
                      />
                      <Communications
                        type="Push Notification"
                        input="is_push_notification"
                        index={3}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    maxHeight: `${heightOfFirstDiv}px`,
                    height: `${heightOfFirstDiv}px`,
                  }}
                  className="tab-container overflow-y-auto flex grow basis-[28%] flex-col border  p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]"
                >
                  <label
                    className={
                      "text-[length:var(--alert-management-title-fs)] font-[var(--alert-management-title-fw)]"
                    }
                  >
                    Available Variables
                  </label>
                  <div className="">
                    <div className="flex flex-col gap-2 mt-6  ">
                      {availableVariables.length > 0 &&
                        availableVariables?.map((variable, index) => (
                          <div
                            key={index}
                            className="text-[length:var(--alert-management-variable-fs)] font-[var(--alert-management-variable-fw)] justify-between flex flex-row px-2 py-[10px] bg-[var(--alert-management-variable-bg)] cursor-pointer"
                            onClick={() => copyToClipboard(variable.value)}
                            onMouseMove={(e) =>
                              handleMouseMove(e, "click to copy")
                            }
                            onMouseLeave={handleMouseLeave}
                          >
                            {variable.label}
                            <CopyIcon />
                          </div>
                        ))}
                      {tooltip.visible && (
                        <div
                          className="fixed z-50 pointer-events-none bg-white text-xs rounded py-1 px-2 whitespace-nowrap transition-opacity"
                          style={{
                            left: `${tooltip.x}px`,
                            top: `${tooltip.y}px`,
                          }}
                        >
                          {tooltip.text}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <LoadingOverlay isLoading={loading} />
              </div>
              <div className="flex flex-row gap-6 p-6 pt-1 w-full">
                <div className=" border w-full flex flex-col gap-[30px]  p-[25px] rounded-[var(--alert-management-border-radius)] border-[var(--alert-management-border-color)]">
                  <div className="flex flex-col gap-[19px]">
                    <label
                      className={
                        "text-[length:var(--alert-management-big-title-fs)] font-[var(--alert-management-title-fw)]"
                      }
                    >
                      Message Configuration
                    </label>
                    <AutoSelectFirstTab
                      setActiveTab={setActiveTab}
                      tabConfig={tabConfig}
                    />
                    <div className="border-b border-[var(--alert-management-nav-border-color)]">
                      <nav className="flex space-x-8">
                        {visibleTabs.map((tab) => (
                          <label
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`py-2 px-1 text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-title-fw)] ${
                              activeTab === tab.id
                                ? "border-[var(--alert-management-nav-text-color)] text-[var(--alert-management-nav-text-color)] border-b-2"
                                : ""
                            }`}
                          >
                            {tab.id}
                          </label>
                        ))}
                      </nav>
                    </div>
                  </div>
                  <div className="flex flex-row gap-6" id={"bottom_div"}>
                    <CommunicationInputData
                      setActiveTabData={setActiveTabData}
                      setShowPreview={setShowPreview}
                      activeTab={activeTab}
                      disabled={disabled}
                    />
                    <Recipients
                      heightOfSecondDiv={heightOfSecondDiv}
                      activeTab={activeTab}
                      groups={groupList}
                      users={usersList}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
              {!disabled && (
                <div className=" mt-auto h-[4rem] flex justify-between px-5 w-full">
                  <div className="flex gap-3 items-center justify-end w-full">
                    <AddButton
                      prefixIcon={false}
                      text={"Clear"}
                      onclkFn={() => onClear(setValues)}
                      className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--trans-stats-con-red-fg)] cursor-pointer
    text-white
    text-[length:var(--draft-button-fs)] 
    font-[var(--draft-button-fw)]
    "
                      type="button"
                    />
                    <AddButton
                      prefixIcon={true}
                      ref={submitRef}
                      isDisabled={disabled}
                      icon={<Save size={14} />}
                      onclkFn={async () => {
                        const formErrors = await validateForm();

                        if (Object.keys(formErrors).length > 0) {
                          const errorMessages = flattenErrors(
                            formErrors,
                            "",
                            controllerRef.current.signal
                          );

                          errorToast(errorMessages[0].message);

                          return;
                        }
                      }}
                      text={
                        <span>
                          Save <span className="opacity-50">(S)</span>{" "}
                        </span>
                      }
                      className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)] 
    font-[var(--primary-button-font-weight)]
    "
                      type="submit"
                    />
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default CreateEditViewAlert;
